import React from "react";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";


export default class EnhancedFilterField extends React.Component {
    renderByType() {
        const { item, value, onHandleQuery, onKeyUp } = this.props;
        let comp= null;
        switch (item.componentType) {
            case "Text":
            case "Textarea":
                comp = (
                    <TextField 
                        value={value}
                        placeholder={`按${item.name}搜索`}
                        onChange={onHandleQuery}
                        onKeyUp={onKeyUp}
                        type="search"
                    />
                );
                break;
            case "Number":
                comp = (
                    <TextField 
                        value={value}
                        placeholder={`按${item.name}搜索`}
                        onChange={onHandleQuery}
                        onKeyUp={onKeyUp}
                        type="number"
                    />
                );
                break;
            case "Select":
            comp = (
                <TextField
                    select
                    label={item.name}
                    style={{ width: 150 }}
                    value={value}
                    margin="normal"
                    onChange={onHandleQuery}
                    onKeyUp={onKeyUp}
                >
                    {item.data.map((item,index) => {
                        return <MenuItem value={item.value} key={index}>{item.name}</MenuItem>
                    })}
                </TextField>
                // <FormControl>
                //     <InputLabel htmlFor={`${item.name}-helper`}>{item.name}</InputLabel>
                //     <Select
                //         style={{ width: 150 }}
                //         input={<Input name={item.name} id={`${item.name}-helper`} />}
                //         value={value}
                //         onChange={onHandleQuery}
                //     >
                //         {(item.data || []).map((item, index) => {
                //             return (
                //             <MenuItem value={item.value} key={index}>
                //                 {item.name}
                //             </MenuItem>
                //             );
                //         })}
                //     </Select>
                // </FormControl>
                );
                break;
            default:
                comp = <div>不认识的类型</div>;
        }
              return comp;
    }
        render() {
            const {item,onCancel, hideCancelBtn} = this.props;
            console.info('EnhancedFilterField',this.props)
            return(
                <div style={{marginRight: 10}}>
                    {this.renderByType(item)}
                    {!hideCancelBtn && <IconButton onClick={()=>onCancel(item.value)}>
                        <HighlightOffIcon />
                    </IconButton>}
                </div>
            );
        }
}





// WEBPACK FOOTER //
// ./src/uis/enhancedFilterFiled.js